/**
 * 「有新版本」的状态：等没等着、用户关没关掉、怎么立即应用。
 *
 * `register.ts` 依赖 `virtual:pwa-register`（只有 vite 构建里才有），测试里 import 不了；
 * 状态单独放在这里，界面与测试都只碰这个 store。
 */
import { create } from 'zustand'

export interface UpdateState {
  readonly waiting: boolean
  /** 用户点了 ×：这一轮不再显示（真到空闲时照样自动更新） */
  readonly dismissed: boolean
  /** 用户点「立即更新」时调用；由 main.tsx 注入 `PwaController.applyUpdate` */
  readonly apply: (() => void) | null
  markWaiting(apply: () => void): void
  dismiss(): void
}

export const useUpdateStore = create<UpdateState>((set) => ({
  waiting: false,
  dismissed: false,
  apply: null,
  markWaiting: (apply) => set({ waiting: true, dismissed: false, apply }),
  dismiss: () => set({ dismissed: true }),
}))
